import React, { useState } from "react";
import { useFormCtx } from "./FormContext";
import dateFormat from "dateformat";
import Navbar from "./components/Navbar";
import Button from "./components/Button";
import Transition from "./components/Transition";
import NotFoundSection from "./components/NotFoundSection";
import ProgressSection from "./components/ProgressSection";
import useMediaQuery from "./hooks/useMediaQuery";
import InfoMessage from "./components/InfoMessage";
import * as Const from "./_Const";

function PageRegSummary() {
  const [showShadow, setShowShadow] = useState(true);
  const { navigateHome, state, isEmptyState, isTaskRunning, lastError } = useFormCtx();
  const path = getPath();
  const isTerminal = Const.isTerminal();
  const showNotFound = isTerminal ? false : isEmptyState();
  const showProgress = !showNotFound && isTaskRunning ? true : false; //(!notFound && !showProgress) ? true : false;;
  const showSummary = !showNotFound && !showProgress && lastError === 0 ? true : false;
  const showConflict = !showNotFound && !showProgress && lastError === 409 ? true : false;

  const now = new Date();

  const isLarge = useMediaQuery("(min-width: 200px)");
  const textCss = isTerminal ? "text-3xl" : "text-xl";
  const containerCss = isTerminal ? "grid grid-cols-2" : "";
  const itemsCss = isTerminal ? "mt-12" : "mt-6";
  const pathCss = isTerminal ? "text-base" : "text-sm";

  // console.log(showNotFound, showProgress, showSummary);

  function getPath() {
    let path = state.queueFullName;
    const name = state.queueName;
    if (path && path.length > 0) {
      if (name && name.length > 0) {
        path = path.replace("" + name, "");
      }
    }

    return path;
  }

  return (
    <>
      <div className="flex flex-col h-dvh overflow-hidden">
        <div className="flex-1 overflow-y-scroll pb-6 overflow-x-hidden">
          <Navbar />
          <Transition exit="none">
            {showConflict && (
              <div className="container mx-auto">
                <InfoMessage
                  title={"Čekejte na vyzvání"}
                  align="grid justify-self-center"
                  className="mt-40"
                  message1={"Již jste v systému registrován"}
                  message2={"Nyní se posaďte a vyčkejte na vyzvání."}
                />
              </div>
            )}
            {showSummary && (
              <div className="container mx-auto">
                <InfoMessage
                  title={"Čekejte na vyzvání"}
                  className="mt-10"
                  message1={"Registrace proběhla úspěšně"}
                  message2={"Nyní se posaďte a vyčkejte na vyzvání."}
                />

                <div className={`${containerCss}`}>
                  <div className={`${itemsCss} mx-6 `}>
                    <p className={`text-primary font-black ${textCss}`}>Pacient</p>
                    <p className={`text-primary ${textCss}`}>
                      {state.firstName} {state.lastName}
                    </p>
                    <p className={`text-primary ${textCss}`}>{state.personalNumber}</p>
                  </div>

                  <div className={`${itemsCss} mx-6 `}>
                    <p className={`text-primary font-black ${textCss}`}>Pojišťovna</p>
                    <p className={`text-primary ${textCss}`}>{state.insurance}</p>
                  </div>

                  <div className={`${itemsCss} mx-6 `}>
                    <p className={`text-primary font-black ${textCss}`}>Důvod návštěvy</p>
                    <p className={`font-light text-secondary ${pathCss}`}>{path}</p>
                    <p className={`text-primary ${textCss}`}> {state.queueName}</p>
                  </div>

                  <div className={`${itemsCss} mx-6 `}>
                    <p className={`text-primary font-black ${textCss}`}>Čas registrace</p>
                    <p className={`text-primary ${textCss}`}>{dateFormat(now, "d.m.yyyy HH:MM:ss")}</p>
                  </div>

                  {state.email && (
                    <div className={`${itemsCss} mx-6 `}>
                      {/* <p className="text-primary font-black text-xl">Rekapitulace e-mailem</p> */}
                      <p className={`text-primary ${textCss}`}>
                        Rekapitulace informací byla zaslána na e-mail <span className="font-bold">{state.email}</span>
                      </p>
                    </div>
                  )}
                </div>
              </div>
            )}

            {showProgress && <ProgressSection title={"Probíhá registrace"} subTitle={"Probíhá registrace do systému, chviličku strpení..."} />}

            {showNotFound && (
              <NotFoundSection
                className="mx-6"
                title={"Stránka nenalezena"}
                subtitle={"Stránka již není aktivní. Pokračujte prosím stisknutím tlačítka"}
                action="Na hlavní obrazovku"
              />
            )}
          </Transition>
        </div>
        {!isTerminal && (
          <footer className={`w-full  ${showShadow && `shadow-[0_1px_17px_5px_rgba(190,228,224,1)]`}`}>
            <div className="grid my-4 mx-6">
              <div className="justify-self-center">
                <Button type="primary" title="Na hlavní obrazovku" showIcon={false} onClick={navigateHome} />
              </div>
            </div>
          </footer>
        )}

        {isTerminal && (
          <footer className="">
            <div className="grid">
              <div className="col-span-3 w-full justify-self-center">
                <Button type="terminal" title="Na hlavní obrazovku" className={"w-full h-20 rounded-none text-3xl"} showIcon={false} onClick={navigateHome} />
              </div>
            </div>
          </footer>
        )}
      </div>
    </>
  );
}

export default PageRegSummary;
